var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"loader":_vm.loadData,"headers":_vm.headers,"title":"Account Deletion Requests","allow-add":false},on:{"done":function($event){return _vm.$router.back()}},scopedSlots:_vm._u([{key:"createdAt",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDate(item.createdAt))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }